import { createAction, props } from "@ngrx/store";

export const OpenSidePanelForCreation = createAction(
  '[Recipes - Shared]: Open Side Panel For Creation',
  props<{ key: string, displayedName: string }>(),
);

export const openConfirmationModal = createAction(
  '[Recipes - Shared]: Open Confirmation Modal', props<{recipeSource: string, actionType: 'create' | 'update'}>()
)

export const closeConfirmationModal = createAction(
  '[Recipes - Shared]: Close Confirmation Modal',
)

export const confirmationChange = createAction(
  '[Recipes - Shared]: Confirmation Modal Confirmation Change', props<{value: string}>()
)